import types from '../mutation-types';
import NotesAPI from '../../api/notes';
import camelcaseKeys from 'camelcase-keys';

// Generico pro Historico em chat (Contact/Company/Deal, spec 127 v7).
// Guarda os registros por subjectType+subjectId pra nao misturar notas
// de entidades diferentes no mesmo estado.
const recordKey = (subjectType, subjectId) => `${subjectType}-${subjectId}`;

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getAllNotesBySubject: _state => (subjectType, subjectId) => {
    const records = _state.records[recordKey(subjectType, subjectId)] || [];
    const notes = records.sort((r1, r2) => r2.id - r1.id);
    return camelcaseKeys(notes, { deep: true });
  },
};

export const actions = {
  async get({ commit }, { subjectType, subjectId }) {
    commit(types.SET_NOTES_UI_FLAG, { isFetching: true });
    try {
      const { data } = await NotesAPI.get(subjectType, subjectId);
      commit(types.SET_NOTES, { subjectType, subjectId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_NOTES_UI_FLAG, { isFetching: false });
    }
  },

  async create({ commit }, { subjectType, subjectId, content, files = [] }) {
    commit(types.SET_NOTES_UI_FLAG, { isCreating: true });
    try {
      const { data } = await NotesAPI.create(
        subjectType,
        subjectId,
        content,
        files
      );
      commit(types.ADD_NOTE, { subjectType, subjectId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_NOTES_UI_FLAG, { isCreating: false });
    }
  },

  async delete({ commit }, { subjectType, subjectId, noteId }) {
    commit(types.SET_NOTES_UI_FLAG, { isDeleting: true });
    try {
      await NotesAPI.delete(subjectType, subjectId, noteId);
      commit(types.DELETE_NOTE, { subjectType, subjectId, noteId });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_NOTES_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_NOTES_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_NOTES]($state, { subjectType, subjectId, data }) {
    $state.records = {
      ...$state.records,
      [recordKey(subjectType, subjectId)]: data,
    };
  },
  [types.ADD_NOTE]($state, { subjectType, subjectId, data }) {
    const key = recordKey(subjectType, subjectId);
    const notes = $state.records[key] || [];
    $state.records[key] = [...notes, data];
  },
  [types.DELETE_NOTE]($state, { subjectType, subjectId, noteId }) {
    const key = recordKey(subjectType, subjectId);
    const notes = $state.records[key] || [];
    $state.records[key] = notes.filter(note => note.id !== noteId);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
